<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
//import content from "@/assets/content.js";

import axios from "axios";
export default {
  name: "App",
  created() {
    setTimeout(
    ()=>{
      this.fundraiserQuery = this.$route.query?.fundraiser}, 2000)
    },
  data() {
    return {
      title: "Rewolucyjna",
      contentA: "",
      loader: true,
      fundraiserQuery: null
    };
  },
  provide() {
    const content = {};
    const loader = {};
    const fundraiserQuery = {};

    Object.defineProperty(content, "data", {
      get: () => this.contentA,
    });
    Object.defineProperty(fundraiserQuery, "data", {
      get: () => this.fundraiserQuery,
    });
    Object.defineProperty(loader, "data", {
      get: () => this.loader,
    });

    return {
      updateCheckoutInfo: this.updateCheckoutInfo,
      content,
      loader,
      fundraiserQuery,
    };
  },

  beforeMount: function() {
    this.getData();
  },
  methods: {
    getData: function() {
      axios
        .get(
          "https://api.rewolucyjna.pl/api/landing-page/content/rewolucyjna",
          {
            headers: { crossDomain: true },
          }
        )
        .then((response) => {
          this.contentA = response.data;
          this.loader = false;
        })
        .catch((e) => {
          console.log("error", e);
        });
    },
  },
  updated() {
    let type = "Pozostałe";

    //, Formularz zamówienia (strona formularza adopcji), Potwierdzenie zamówienia (strona z potwierdzeniem złożenia zamówienia), Błąd 404
    if (this.$route.fullPath == "/") {
      type = "Strona główna";
    }
    if (this.$route.fullPath.includes("error")) {
      type = "Błąd 404";
    }
    if (this.$route.fullPath.includes("thankyou_")) {
      type = " Potwierdzenie zamówienia";
    }

    window.trackUrl(document.title + " | " + this.$route.fullPath, type);
  },    
};

window.trackAdoptionForm = function() {
  //console.log("trackAdoption");
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "virtualPageview",
    virtualPageURL: "/formularz",
    virtualPageTitle: "Formularz zamówienia",
    pageType: "Formularz zamówienia",
    viewForm: "1",
  });
};

window.trackUrl = function(title, type) {
  //console.log("trackUrl");
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "virtualPageview",
    virtualPageURL: window.location.pathname,
    virtualPageTitle: title,
    pageType: type,
  });
};
window.trackClickButton = function(buttonName) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "clickButton",
    buttonName: buttonName,
    buttonAdopt: "1",
  });
};

window.trackFormClick = function(event, formName, fieldName, clickField) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: event,
    formName: formName,
    fieldName: fieldName,
    clickField: clickField,
  });
};

window.goToPayment = function() {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "formSubmitted",
    formName: "Formularz ",
    sendForm: "1",
  });
};

window.clickAdoptujButton = function() {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "clickButton",
    buttonName: "Przycisk ",
    buttonAdopt: "1",
  });
};

window.formFieldClick = function(fieldName) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "formClickField",
    formName: "Formularz ",
    fieldName: fieldName,
    clickField: "1",
  });
};

window.errorOnFormField = function(fieldName, errorMessage) {
  let dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "formFieldError",
    formName: "Formularz ",
    fieldName: fieldName,
    errorMessage: errorMessage,
    errorField: "1",
  });
};
</script>

<style lang="scss">
@import "src/assets/scss/main.scss";
</style>
